import store from "@/store";

import { getBearerToken } from "@/auth/tokens.js";

const buildSubscription = ({
  onSubscriptionLoadStatusUpdate,
  variables,
  onSuccess,
  errorNotificationMessage,
  ...options
}) => {
  return {
    variables: mergeAuthVariables(variables),
    result({ data }) {
      onSubscriptionLoadStatusUpdate(true);

      if (isEmptyObject(data)) return;

      onSuccess(data);
    },
    error() {
      onSubscriptionLoadStatusUpdate(false);

      notifySubscriptionError(errorNotificationMessage);
    },
    ...options,
  };
};

const isEmptyObject = (object) => {
  return Object.keys(object).length === 0;
};

const mergeAuthVariables = (variables) => {
  return {
    bearerToken: getBearerToken(),
    ...variables,
  };
};

const notifySubscriptionError = (message) => {
  store.dispatch("createNotification", {
    type: "error",
    message,
  });
};

export { buildSubscription };
